/// <amd-module name="Feed/Legacy/Actions/FeedSettings/UpgradeFeedHandler" />
import { IFeedSettingsState } from "Feed/Legacy/Components/Settings/IFeedSettingsState";
import { IFeedDataService } from "Feed/Legacy/DataServices/FeedsDataService";
import { Feed, FeedCapabilities } from "Feed/Common/Contracts/Feed";

/**
 * The user clicked save in feed details pivot
 */
export class UpgradeFeedHandler {
    public static async handleAsync(state: IFeedSettingsState): Promise<Feed> {
        const feedDataService = state.pageContext.getService<IFeedDataService>("IFeedDataService");
        /* not a project scoped call because you can only upgrade V1 feeds and all V1 feeds are collection scoped feeds */
        await feedDataService.updateCapability(
            state.feed().id,
            state.feed().capabilities | FeedCapabilities.UpstreamV2
        );
        state.upgradeInProgress = true;
        return this.getFeedAsync(state);
    }

    private static async getFeedAsync(state: IFeedSettingsState): Promise<Feed> {
        const feedDataService = state.pageContext.getService<IFeedDataService>("IFeedDataService");
        const feed = state.feed();
        return feedDataService.getFeedAsync(
            null /*projectId: null because all V1 feeds are collection scoped feeds */,
            feed.id
        );
    }
}
